import { getHeightAvailableConfig } from './getHeightAvailableConfig'

export const observeHeightAvailable = (el: HTMLElement) => {
  const config = getHeightAvailableConfig()
  if (!config) return
  config.elements.add(el)
  config.observer.observe(el)
  config.schedule()
}
